import React from "react";
import HeadTags from "components/HeadTags";
import FAQAccordion from "./faqAccordion";

const Faq = () => {
  return (
    <>
      <HeadTags title="FAQ's" />
      <div className="contentPage">
        <div>
          <div className="contentPage__headingDiv">
            <h1>Frequently Asked Questions</h1>
          </div>
          <FAQAccordion count={0} />
        </div>
      </div>
    </>
  );
};

export default Faq;
